import { getSidebarModules } from "../../../api/divvy-sidebarModules";

const sidebarModules = {
  state: () => ({
    sidebarModules: [],
    sidebarSubModules: [],
  }),

  getters: {
    getSidebarModules(state) {
      return state.sidebarModules;
    },
    getSidebarSubModules(state) {
      return state.sidebarSubModules;
    },
  },

  actions: {
    fetchSidebarModules({ commit }, params) {
      return new Promise((resolve, reject) => {
        // console.log("hello from sidebarModules fetch");
        getSidebarModules(params)
          .then((resp) => {
            // console.log(resp, "sidebarModules api");
            resolve(resp);
            commit("SET_SIDEBAR_MODULES", resp);
            commit("SET_SIDEBAR_SUBMODULES", resp);
          })
          .catch(() => {
            console.log("error");
          });
      });
    },
  },

  mutations: {
    SET_SIDEBAR_MODULES: (state, modules) => {
      state.sidebarModules = modules;
    },
    SET_SIDEBAR_SUBMODULES: (state, modules) => {
      modules.map((mod) => {
        const submodules = mod.sub_modules;
        state.sidebarSubModules.push(...submodules);
      });
      localStorage.setItem(
        "sidebarSubModules",
        JSON.stringify(state.sidebarSubModules)
      );
    },
  },
};

export default sidebarModules;
